import {useEffect} from 'react';

/**
 *
 * @param {string} children
 */
const Title = ({ children }) => {
    useEffect(() => {
        const originalTitle = document.title;
        document.title = children;

        return () => document.title = originalTitle;
    }, [children]);

    return null;
};

export default Title;
